/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Joor_SyncInputs */

const en_col_joor_sync = /** @type {(inputs: Col_Joor_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joor`)
};

/**
* | output |
* | --- |
* | "Joor" |
*
* @param {Col_Joor_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_joor_sync = /** @type {((inputs?: Col_Joor_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Joor_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_joor_sync(inputs)
});